<template>
  <div class="flex-row">
    <div class="selvideo_left">
      <div class="selvideo_left_con">
        <el-button size="small" class="mr-10" type="primary" @click="selectNowPage"
          >全选</el-button
        >
        <el-input
          placeholder="请输入搜索内容"
          v-model="filterText"
          size="small"
          class="se-in"
        >
        </el-input>
        <el-button size="small" type="primary" @click="queryList"
          >查询</el-button
        >
        <el-button size="small" @click="resetList">重置</el-button>
      </div>
      <div class="selvideo_left_tree">
        <el-tree
          v-if="isShow"
          @check-change="handleCheckChange"
          class="filter-tree"
          show-checkbox
          :data="setData"
          node-key="uuid"
          :props="defaultProps"
          :filter-node-method="filterNode"
          :default-checked-keys="renderKeys"
          ref="tree2"
        ></el-tree>
      </div>
      <div class="select_pagination">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page.sync="page"
          layout="total, prev, pager, next"
          :page-size="limit"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <div class="selvideo_right">
      <div class="swicth_con">
        <div class="sw_tip">
          <span v-text="'已选' + this.title + ' (' + this.selNum + ') '"></span>
          <span class="clear_btn" @click="reset">清空</span>
        </div>
        <ul>
          <li v-for="(item, index) in renderList" :key="index">
            <span v-text="item[param]"></span>
            <i class="icon-del" @click="delPerson(item)"></i>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import vue from "@/main";
import { getNoRVideo } from "@/api/videoSet";
export default {
  data() {
    return {
      selNum: 0,
      renderList: [],
      limit: 10,
      page: 1,
      total: 0,
      filterText: "",
      isShow: false,
      treeData: [],
      setData: [],
      selectedMembers: [],
      defaultProps: {
        children: "children",
        label: "",
      },
    };
  },
  props: ["renderData", "renderKeys", "title", "param"],
  watch: {
    // filterText(val) {
    //   this.$refs.tree2.filter(val);
    // },
    renderList() {
      this.isShow = true;
    },
  },
  created() {
    vue.$on("setManage", (data) => {
      (this.total = data.total), (this.setData = data.records);
    });
  },
  beforeDestroy() {
    vue.$off("setManage");
  },
  mounted() {
    this.defaultProps.label = this.param;
    this.defaultProps.value = "uuid";
    this.initCheckNodes();
  },
  methods: {
    selectNowPage() {
       this.$refs["tree2"].setCheckedNodes(this.setData)
    },
    queryList() {
      this.page = 1;
      this.getMembers();
    },
    resetList() {
      this.page = 1;
      this.filterText = "";
      this.getMembers();
    },
    handleCurrentChange(p) {
      this.page = p;
      this.getMembers();
    },
    // 获取视频：全部节点数据
    getMembers() {
      let params = {
        page: this.page,
        uuid: "",
        limit: this.limit,
        videoName: this.filterText,
      };
      getNoRVideo(params).then((res) => {
        if (!res || res.code != 0) return;
        this.setData = res.data.records;
        this.total = res.data.total;
        if (this.renderList.length > 0) {
          this.$refs["tree2"].setCheckedKeys(
            this.renderList.map((x) => x.uuid)
          );
        }
      });
    },
    delPerson(item) {
      for (var i = 0; i < this.renderList.length; i++) {
        if (this.renderList[i].uuid == item.uuid) {
          this.renderList.splice(i, 1);
        }
      }
      this.$refs.tree2.setCheckedNodes(this.renderList);
      this.selNum = this.renderList.length;
    },
    initCheckNodes() {
      this.isShow = true;
      this.renderList = this.renderData;
      this.selNum = this.renderList.length;

      this.$nextTick(() => {
        this.$refs.tree2.setCheckedKeys(this.renderList.map((ele) => ele.uuid));
      });
    },
    handleCheckChange(data, checked, node) {
      if (checked) {
        this.renderList.push(data);
      } else {
        console.log("xxxxx:", data);
        let uuid = data.uuid;
        let uuids = this.renderList.map((ele) => ele.uuid);
        let index = uuids.indexOf(uuid);
        if (index !== -1) {
          this.renderList.splice(index, 1);
        }
      }
      this.selNum = this.renderList.length;
      this.$emit("change-sel", this.renderList);
    },
    //树结构搜索
    filterNode(value, data) {
      if (!value) return true;
      return data.videoName.indexOf(value) !== -1;
    },
    reset() {
      this.renderList = [];
      this.selNum = 0;
      this.$refs.tree2.setCheckedNodes([]);
      this.$emit("change-sel", this.renderList);
    },
  },
};
</script>

<style lang="scss" scoped>
.flex-row {
  display: flex;
  justify-content: space-between;
}
.selvideo_left_con {
  padding-bottom: 10px;
}
.swicth_con {
  width: 100%;
  // max-height: 400px;
  border-radius: 2px;
  border: 1px solid rgb(235, 238, 245);
  ul {
    max-height: 400px;
    overflow: auto;
    margin: 0;
    list-style: none;
    padding: 10px 0;
    box-sizing: border-box;
    li {
      line-height: 30px;
      width: 100%;
      display: inline-block;
      padding: 0 10px;
      box-sizing: border-box;
      color: #51627d;
      i {
        float: right;
        line-height: 30px;
      }
    }
    li:hover {
      background: rgba(242, 243, 244, 1);
    }
  }
}
.sw_tip {
  display: inline-block;
  line-height: 40px;
  padding-left: 10px;
  background-color: #f2f3f4;
  width: 100%;
  color: #343c4a;
  box-sizing: border-box;
  .clear_btn {
    float: right;
    padding-right: 10px;
    color: #96a1b2;
    cursor: pointer;
  }
}
.icon-del {
  height: 30px;
  width: 30px;
  background: url("../../assets/image/btn/icon_delete@2x.png") no-repeat;
  background-size: 12px 12px;
  background-position: center;
  cursor: pointer;
}
.selvideo_left {
  width: 430px;
  // height: 300px;
}
.selvideo_left_tree {
  overflow: auto;
  max-height: 400px;
  background-color: white;
}
.selvideo_right {
  text-align: left;
  width: 380px;
}
.select_pagination {
  width: 98%;
  height: 50px;
  overflow-x: auto;
}
/deep/.el-tree-node {
  white-space: normal;
  height: 35px;
}
.course-hand {
  cursor: pointer;
}
.se-in {
  width: 200px;
  margin-right: 10px;
}
.mr-10 {
  margin-right: 10px;
}
</style>
